import React from 'react'
import GenHeader from '../components/Generated/GenHeader'

const Generated = () => {
    return (
        <GenHeader />
    )
}

export default Generated;